import { Injectable } from "@angular/core";
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { CustomerContactData } from "../domain/models/customer.model";
import { CustomerFacade } from "../domain/+state/customer.facade";

@Injectable({ providedIn: "root" })
export class CustomerContactDetailsResolver
  implements Resolve<CustomerContactData>
{
  constructor(private facade: CustomerFacade) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<CustomerContactData> {
    return this.facade.getCustomerContactDetails$().pipe(take(1));
  }
}
